import { useI18n } from "@core/i18n/i18n";
import {
	sendAnalyticsEventProgramDurationExtendedShortcut,
	sendAnalyticsEventSetProgramDurationShortcut,
} from "@domain/program/program-analytics";
import { ProgramStatus } from "@domain/program/program-status/program-status";
import { now } from "@utils/date-utils";
import { Dayjs } from "dayjs";

const SHORTCUTS_MONTH_LIST = [3, 6, 9];

export const useScheduleShortcuts = (
	programStatus: ProgramStatus,
	startDate: Dayjs | undefined,
	endDate: Dayjs | undefined,
): { label: string; newDate: Dayjs; sendAnalyticsEvent: () => void }[] => {
	const { format } = useI18n();

	switch (programStatus) {
		case ProgramStatus.Ongoing:
			return SHORTCUTS_MONTH_LIST.map(month => ({
				label: format("programBuilder.scheduleDialog.addShortcut", { month }),
				newDate: (endDate ?? startDate ?? now()).add(month, "month").endOf("week"),
				sendAnalyticsEvent: () => sendAnalyticsEventProgramDurationExtendedShortcut(month),
			}));
		case ProgramStatus.Scheduled:
		case ProgramStatus.Draft:
			return SHORTCUTS_MONTH_LIST.map(month => ({
				label: format("programBuilder.scheduleDialog.inShortcut", { month }),
				newDate: (startDate ?? now()).add(month, "month").endOf("week"),
				sendAnalyticsEvent: () => sendAnalyticsEventSetProgramDurationShortcut(month),
			}));
		case ProgramStatus.Ended:
			return [];
	}
};
